import { QueryClient } from '@tanstack/react-query';

/**
 * Global registry for QueryClient instance
 * This allows non-React code (like HTTP error handlers) to access the QueryClient
 */
let globalQueryClient: QueryClient | null = null;

/**
 * Register the QueryClient instance for global access
 * This should be called once during app initialization
 *
 * @param queryClient - The QueryClient instance to register
 */
export function registerQueryClient(queryClient: QueryClient): void {
  globalQueryClient = queryClient;
}

/**
 * Get the registered QueryClient instance
 *
 * @returns The registered QueryClient instance, or null if not registered
 */
export function getQueryClient(): QueryClient | null {
  return globalQueryClient;
}
